import { Link } from "react-router-dom";

export default function FooterThree(){
    return(
        <>
            <footer className="footer-area footer-a3 pt-95">
                <div className="container">
                    <div className="row mb-15">
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".1s">
                            <div className="footer__widget mb-30">
                                <h6 className="widget-title text-white pb-15 mb-35">Get In Touch</h6>
                                <address className="address-box">
                                    <span>2307 Beverley Rd</span>
                                    <span>Brooklyn, New York 11226</span>
                                    <span>United States.</span>
                                </address>
                                <address>
                                    <span><b className="text-white">Open:</b> Monday to Saturday</span>
                                    <span>From 7h to 18h or talk to an expert</span>
                                    <span>0712-0610-3314 – available 24/7</span></address>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".3s">
                            <div className="footer__widget mb-30">
                                <h6 className="widget-title text-white pb-15 mb-35">Quick links</h6>
                                <ul className="fot-list fot-flex">
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/faq">FAQs</Link></li>
                                    <li><Link to="/services">Our Services</Link></li>
                                    <li><Link to="/team">Meet Our Team</Link></li>
                                    <li><Link to="/portfolio">All Industries</Link></li>
                                    <li><Link to="/about">Mission & Values</Link></li>
                                    <li><Link to="/case-details">Case Studies</Link></li>
                                    <li><Link to="/history">Our Approach</Link></li>
                                    <li><Link to="/about">Insights</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".5s">
                            <div className="footer__widget form-widget mb-30">
                                <h6 className="widget-title text-white pb-20 mb-35">Subscribe Now</h6>
                                <p>Sign up to receive the latest articles</p>
                                <form className="subscribe-form" action="#">
                                    <div className="input-box mail-input mb-10">
                                        <input type="text" placeholder="Enter email address" />
                                    </div>
                                    <button className="theme_btn subscribe-btn">Subscribe Now <i
                                            className="fal fa-long-arrow-right"></i></button>
                                </form>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".7s">
                            <div className="footer__widget mb-30 pl-55 pl-lg-0 pl-md-0 pl-xs-0">
                                <h6 className="widget-title text-white pb-15 mb-35">Our Services</h6>
                                <ul className="fot-list">
                                    <li><Link to="/contact">IT Support</Link></li>
                                    <li><Link to="/contact">IT Consultancy</Link></li>
                                    <li><Link to="/services">Cloud Computing</Link></li>
                                    <li><Link to="/services">Cyber Security</Link></li>
                                    <li><Link to="/contact">Custom Software</Link></li>
                                </ul>
                            </div>
                        </div>/
                    </div>
                </div>
                <div className="container pt-35">
                    <div className="copy-white row white-bg align-items-center gx-lg-0 pt-15">
                        <div className="col-xl-3 col-lg-4 col-md-6 text-center text-md-start">
                            <div className="logo-area mb-15 pl-30 pl-md-0 pl-xs-0">
                                <Link to="/"><img src="assets/img/logo/header-logo-1.png" alt="Footer-logo" /></Link>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 text-center text-md-start">
                            <div className="copyright copy-line">
                                <h6>Copyright ©Copyright ©{new Date().getFullYear()} Waretech. Designed & Developed
                                    by <Link to="">Reacthemes</Link></h6>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-4 col-md-12 text-center text-lg-end pr-25 pr-md-15 pr-xs-15">
                            <div className="footer__social mb-10">
                                <Link to="#"><i className="fab fa-facebook-f"></i></Link>
                                <Link to="#"><i className="fab fa-twitter"></i></Link>
                                <Link to="#"><i className="fab fa-linkedin-in"></i></Link>
                                <Link to="#"><i className="fab fa-youtube"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
	        </footer>

            <div className="search-wrap">
                <div className="search-inner">
                    <i className="fas fa-times search-close" id="search-close"></i>
                    <div className="search-cell">
                        <form method="get">
                            <div className="search-field-holder">
                                <input type="search" className="main-search-input" placeholder="Search Your Keyword..." />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}